import styled from 'styled-components';
import { Card as CommonCard } from '../../../common/Card/Card';

export const Card = styled(CommonCard)`
  margin-bottom: 2rem;
  width: 50em;
`;